export default __webpack_public_path__ + "static/media/SubWebEvents.6abeb46f.png";